<ph-dialog [open]="open" size="sm" no-close [heading]="copy.title" [description]="copy.intro" (ph-close)="closed.emit({ startVerification: false })">
    <ph-toolbar slot="band" inline nowrap align="center">
        <ph-logo size="sm"></ph-logo>
        <ph-divider orientation="vertical"></ph-divider>
        <ph-toolbar inline nowrap align="center" gap="tight">
            <ph-hint>secured by</ph-hint>
            <img [src]="stripeWordmark" alt="Stripe" height="20">
        </ph-toolbar>
    </ph-toolbar>
    <ph-stack>
        <ph-stack align="start">
            <ph-badge color="blue" variant="lighter"><ph-icon name="clock" size="sm"></ph-icon>Takes about 3 minutes</ph-badge>
        </ph-stack>
        <ph-card flat>
            <ph-stack gap="snug">
                <ph-label>Have ready</ph-label>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <ph-avatar size="32" color="gray" icon="suitcase-simple" aria-hidden="true"></ph-avatar>
                    <span>Your HOA's legal name, address, and EIN</span>
                </ph-toolbar>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <ph-avatar size="32" color="gray" icon="user-list" aria-hidden="true"></ph-avatar>
                    <span>Contact information for the authorized representative</span>
                </ph-toolbar>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <ph-avatar size="32" color="gray" icon="identification-card" aria-hidden="true"></ph-avatar>
                    <span>A photo ID for the authorized representative</span>
                </ph-toolbar>
            </ph-stack>
        </ph-card>
        <ph-auth-note tone="neutral" icon="lock-key">
            <span>You'll enter this on Stripe's secure form. It's encrypted in transit, and PayHOA never sees or stores your ID, SSN, or bank credentials.</span>
        </ph-auth-note>
        <ph-hint><span [innerHTML]="disclosureText"></span></ph-hint>
    </ph-stack>
    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" (click)="closed.emit({ startVerification: false })">Cancel</ph-button>
        <ph-button trailing-icon="arrow-right" (click)="closed.emit({ startVerification: true })">Start verification</ph-button>
    </ph-actions>
</ph-dialog>
